import { linkToAssignmentPage } from "../../links";

export function linkToAssignmentStudentResult(
  classId?: string,
  assignmentId?: string,
  userId: string = ":userId"
) {
  return `${linkToAssignmentPage(classId, assignmentId)}/user/${userId}`;
}
